module.exports = __webpack_public_path__ + "img/p1-orange.5e789370.png";